import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.inventory-history-item-form', () => {
  void import('./internal/inventory-history-item-form')
    .then(({ default: Component }) => Component());
});
